function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, React.createElement("polyline", {
  fill: "none",
  points: "   649,137.999 675,137.999 675,155.999 661,155.999  ",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("polyline", {
  fill: "none",
  points: "   653,155.999 649,155.999 649,141.999  ",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("polyline", {
  fill: "none",
  points: "   661,156 653,162 653,156  ",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  d: "M29,27H3c-0.552,0-1-0.447-1-1V10c0-0.552,0.448-1,1-1s1,0.448,1,1v15h24V7H3C2.448,7,2,6.552,2,6s0.448-1,1-1h26   c0.553,0,1,0.448,1,1v20C30,26.553,29.553,27,29,27z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  d: "M16,19c-0.256,0-0.512-0.098-0.707-0.293l-8-8c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0L16,16.586   l7.293-7.293c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-8,8C16.512,18.902,16.256,19,16,19z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  d: "M24.001,23c-0.256,0-0.512-0.098-0.707-0.293l-3.002-3.002c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0   l3.002,3.002c0.391,0.391,0.391,1.023,0,1.414C24.513,22.902,24.257,23,24.001,23z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  d: "M8.001,23c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l2.999-2.999   c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-2.999,2.999C8.513,22.902,8.257,23,8.001,23z"
}));

var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    focusable: "false",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.cd6f09b9.svg";
export { ForwardRef as ReactComponent };